<template>

    <b-row>

        <b-col cols="12" v-if="matriculaIban">

            <h4 class="fuid-resu-tit no-border">{{ $t('paymentok.tit') }}</h4>

        </b-col>

        <b-col cols="12" >

            <errorFromServer
                :id="id"
            />

        </b-col>

        <b-col cols="12 d-flex justify-content-center" >

            <form ref="redsys_form" :action="formAction" method="post" id="redsys_form" name="redsys_form">

                <input type="text" name="Ds_SignatureVersion" v-model="Ds_SignatureVersion" hidden />
                <input type="text" name="Ds_MerchantParameters" v-model="Ds_MerchantParameters" hidden />
                <input type="text" name="Ds_Signature" v-model="Ds_Signature" hidden />

                <button class="fuid-button fuid-button-step align-items-center" @click.prevent="checkPayment()">

                    <b-spinner v-if="loading" variant="light" label="Loading..."></b-spinner>
                    <span v-else>{{$t('forms.pay')}}</span>

                </button>

            </form>

        </b-col>

        <!-- {{paymentData.DS_MERCHANT_ORDER}} -->

        <div>

            <b-modal
                id="modalTpv"
                v-model="modal"
                title="TPV info"
                @ok="ok"
                ok-only
                centered
            >

                <template v-slot:modal-header="{ close }">

                    <h5>{{ $t('forms.infotpv') }}</h5>

                    <div class="close" @click="close()">

                        <Close />

                    </div>

                </template>

                <p v-html="$t('forms.infotpvtext')"></p>

                <template v-slot:modal-footer="{ ok }" class="justify-content-center">

                    <button class="fuid-button fuid-button-step align-items-center" @click="ok()">

                        <b-spinner v-if="loading" variant="light" label="Loading..."></b-spinner>
                        <span v-else>{{ $t('forms.pay') }}</span>

                    </button>

                </template>

            </b-modal>

        </div>

    </b-row>

</template>

<script>

    import { mapActions } from 'vuex'
    import Close from '@/assets/svg/close.vue'
    import errorFromServer from '@/components/errorFromServer'
    import scrollTo from '@/mixins/scrollTo'

    export default {

        props:['amount','valid','paymentMethod'],

        data() {

            return {
                id: 6,
                data: null,
                loading: false,
                clicked: 0,
                modal: false,
                Ds_Merchant_MerchantCode: 999008881,
                matriculaIban: false,
                formAction: process.env.VUE_APP_TPV_URL,
                paymentData: {
                    DS_MERCHANT_AMOUNT: "",
                    DS_MERCHANT_CURRENCY: "978",
                    DS_MERCHANT_MERCHANTCODE: "059350272",
                    DS_MERCHANT_MERCHANTURL: `${process.env.VUE_APP_BASE_URL}${this.$i18n.locale}/tpv-callback`,
                    DS_MERCHANT_ORDER: "",
                    DS_MERCHANT_TERMINAL: "1",
                    DS_MERCHANT_TRANSACTIONTYPE: "0",
                    DS_MERCHANT_URLKO: `${process.env.VUE_APP_BASE_URL}${this.$i18n.locale}/tpv-pago-ko`,
                    DS_MERCHANT_URLOK: `${process.env.VUE_APP_BASE_URL}${this.$i18n.locale}/tpv-pago-ok`
                },
                Ds_MerchantParameters: null,
                Ds_Signature: null,
                Ds_SignatureVersion: null
            }

        },

        components: {

            Close,
            errorFromServer

        },

        mixins: [scrollTo],

        computed: {

            n() {

                return this.valid.n

            }

        },

        methods: {

            ...mapActions('Matricula', ['checkMatricula']),

            async checkPayment() {

                this.clicked++
                this.$emit('validateForm', { value: this.clicked } )

            },

            /**
             * When pay is TPV: Ok button from the modal
             *
             */
            async ok(bvModalEvt) {

                bvModalEvt.preventDefault()

                this.loading = true

                let matriculaOK = await this.checkMatricula({componentId: this.id})

                if ( matriculaOK && matriculaOK.numeroPedido ) { // Matricula ok && order ok to TPV

                    this.paymentData.DS_MERCHANT_ORDER = matriculaOK.numeroPedido

                    let send = await this.encodePayment()

                    if ( send ) {

                        localStorage.removeItem('logged')
                        this.$refs.redsys_form.submit()

                    }

                } else if ( Object.keys(matriculaOK.ko).length > 0 ) { // Some group is full

                    this.groupFullError( matriculaOK.ko )

                    this.modal = false

                    this.scrollToError()

                } else {

                    this.$store.dispatch('Errors/setError', { error:'CODE01', componentId: this.id }, { root: true })

                }

                this.loading = false

            },

            /**
             * When pay is iBAN
             *
             */
            async payIban() {

                this.loading = true

                let matriculaOK = await this.checkMatricula({componentId: this.id})

                if ( Object.keys(matriculaOK.ok).length > 0 ) { // Matricula ok

                    // this.matriculaIban = true
                    this.$router.push( `/${this.$i18n.locale}/iban-ok` )

                } else if ( Object.keys(matriculaOK.ko).length > 0 ) { // Some group is full

                    this.groupFullError( matriculaOK.ko )

                    this.scrollToError()

                } else { // Server error

                    this.$store.dispatch('Errors/setError', { error:'CODE01', componentId: this.id }, { root: true })

                }

                this.loading = false

            },

            /**
             * When a group is no longer avaliable
             *
             */
            groupFullError(ko) {

                let keys = Object.keys(ko)
                let ids = []

                keys.forEach((key, index) => {

                    ids = ids.concat(ko[key])

                })

                this.$emit('seatsCheck', {ids: ids})

            },

            /**
             * Encode all the data for the post to redsys
             *
             */
            async encodePayment() {

                try {

                    this.priceForRedsys()

                    // Uses --> https://cryptojs.gitbook.io/docs/

                    // Lets make a string encoded in Base64 with the object width the data
                    let merchant = this.$CryptoJS.enc.Utf8.parse(JSON.stringify(this.paymentData))

                    this.Ds_MerchantParameters = merchant.toString(this.$CryptoJS.enc.Base64)

                    // Decode from Base 64 the secret key of the commerce from Redsys

                    let key = this.$CryptoJS.enc.Base64.parse(process.env.VUE_APP_TPV_SECRECT_KEY)

                    // Encrypt the key diversified with the order number in TripleDes

                    let iv = this.$CryptoJS.enc.Hex.parse("0000000000000000");
                    let cipher = this.$CryptoJS.TripleDES.encrypt(this.paymentData.DS_MERCHANT_ORDER, key, {
                        iv:iv,
                        mode: this.$CryptoJS.mode.CBC,
                        padding: this.$CryptoJS.pad.ZeroPadding // Redsys dont like padding
                    })

                    // Signature HASH width de merchant parameters in Base 64 and the TripleDes

                    let signature = this.$CryptoJS.HmacSHA256(this.Ds_MerchantParameters, cipher.ciphertext);

                    this.Ds_Signature = signature.toString(this.$CryptoJS.enc.Base64)

                    this.Ds_SignatureVersion = "HMAC_SHA256_V1"

                    return true

                } catch (error) {

                    // console.log(error)

                    return false

                }

            },

            /**
             * Set the amount in the correct format for Redsys (the last two characters are the decimals)
             *
             */
            priceForRedsys() {

                let priceN = parseFloat ( this.amount )

                if( Number.isInteger(priceN) ){

                    this.paymentData.DS_MERCHANT_AMOUNT = priceN.toString() + '00'

                } else {

                    let price_fixed = priceN.toFixed(2).toString()

                    let price_string = price_fixed.replace('.','')

                    this.paymentData.DS_MERCHANT_AMOUNT = price_string

                }

            }

        },

        watch: {

            n: function(value) {

                if(this.valid.value == true && this.paymentMethod == 1) {

                   this.modal = true

                }

                if(this.valid.value == true && this.paymentMethod == 2) {

                   this.payIban()

                }

            }

        }

    }
</script>
